import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';

import './video.scss';

const styles = bemGenerator('pj-ui-carousel-video', ['children']);

const Video = props => {
  if (!props.inView && props.hideWhenNotInView) {
    return null;
  }

  return (
    <div className={styles.block}>
      <iframe src={props.src} title={props.src} />
      <div className={styles.children}>{props.children}</div>
    </div>
  );
};

const { string, bool, node } = PropTypes;

Video.propTypes = {
  src: string.isRequired,
  children: node,
  inView: bool,
  hideWhenNotInView: bool,
};

Video.defaultProps = {
  children: null,
  inView: false,
  hideWhenNotInView: true,
};

export default Video;
